import {Injectable} from '@angular/core';
import {HttpService} from './http-service';
import {Observable} from 'rxjs/Rx';

import {LogadoService} from './logado-service';
import {TAction, TConviteTipo} from "../app/enum";

@Injectable()
export class EntrakiService {

    response: any = {};
    perfil: any = {};

    constructor(public http: HttpService, public authService: LogadoService) {

    }

    entraki(action: TAction, hotspotID: number, spotdayID: number, profileID: number, profileRnid: string = '', conviteTipo: TConviteTipo = TConviteTipo.ctConvitePorta): Observable<any> {

        let url = 'SYNC-Entraki?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&SpotdayID=' + spotdayID + '&ProfileID=' + profileID + '&ProfileRnid=' + profileRnid + '&ConviteTipo=' + conviteTipo;

        return this.http.get(url);

    }

    convite(action: TAction, hotspotID: number, spotdayID: number, ambientID: number, json: any = null): Observable<any> {

        let url = 'SYNC-Convite?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&SpotdayID=' + spotdayID + '&AmbientID=' + ambientID;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    voucher(action: TAction, hotspotID: number, profileID: number, profileRnid: string = '', notifyeID: number = 0, ambientID: number = 0, usuarioID: number = 0, spotdayID: number = 0, voucherID: number = 0, voucherHash: string = '', json: any = null): Observable<any> {

        let url = 'SYNC-Voucher?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID + '&ProfileRnid=' + profileRnid + '&NotifyeID=' + notifyeID + '&AmbientID=' + ambientID + '&UsuarioID=' + usuarioID + '&SpotdayID=' + spotdayID + '&VoucherID=' + voucherID + '&VoucherHash=' + voucherHash;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    payment(action: TAction, carbook: any): Observable<any> {

        let url = 'SYNC-Gateway?Action=' + TAction[action];

        let dataJSon = 'JSon=' + JSON.stringify(carbook);

        return this.http.post(url, dataJSon);

    }

}



// WEBPACK FOOTER //
// ./src/providers/entraki-service.ts